import PagamentoLoteNovoComponent from "../../components/pagamento-lote/novo-lote/PagamentoLoteNovo";

export default function PagamentoLoteNovo() {
  return <PagamentoLoteNovoComponent />;
}
